import React from 'react'

const ResumeSection = class extends React.Component {
  render() {
    return (
      <section className="elementor-section resume-section">
          <div className="elementor-container">
            <div className="row">
                <div className="col-12 col-md-6">
                    <div className="elementor-column-wrap elementor-element-populated">
                        <div className="elementor-widget-wrap">
                            <div className="elementor-widget-container">
                                <div className="art-section-title">
                                    <div className="art-title-frame">
                                        <h4 className="art-title-h"> <span> Education </span></h4>
                                    </div>
                                </div>
                                <div className="art-timeline">
                                    <div className="art-timeline-item">
                                        <div className="art-timeline-mark-light"></div>
                                        <div className="art-timeline-mark"></div>
                                        <div className="art-timeline-content">
                                            <div className="art-card-header">
                                                <div className="art-left-side">
                                                    <h5> <span> Online web development courses </span></h5>
                                                    <div className="art-el-suptitle mb-15"> 
                                                        <span> Student </span>
                                                    </div>
                                                </div>
                                                <div className="art-right-side"> 
                                                    <span className="art-date"> <span> Jun 2018 ~ Now </span> </span>
                                                </div>
                                            </div>
                                            <div className="art-el-description">
                                                <p>I always thirsty to learn new skills and technologies</p>
                                            </div> 
                                            {/* <a href="https://bslthemes.com/arter-demo/wp-content/uploads/2020/09/certificate.jpg" className="art-link art-color-link art-w-chevron"> <span> Diplome </span> </a> */}
                                        </div>
                                    </div>
                                    <div className="art-timeline-item">
                                        <div className="art-timeline-mark-light"></div>
                                        <div className="art-timeline-mark"></div>
                                        <div className="art-timeline-content">
                                            <div className="art-card-header">
                                                <div className="art-left-side">
                                                    <h5> <span> ReBootKamp(RBK) </span></h5>
                                                    <div className="art-el-suptitle mb-15"> 
                                                        <span> Student </span>
                                                    </div>
                                                </div>
                                                <div className="art-right-side"> 
                                                    <span className="art-date"> <span> Dec 2017 ~ Jun 2018 </span> </span>
                                                </div>
                                            </div>
                                            <div className="art-el-description">
                                                <p>A coding bootcamp focused on producing self-contained software developers ready for any job in the technology industry.</p>
                                            </div> 
                                            {/* <a href="https://bslthemes.com/arter-demo/wp-content/uploads/2020/09/certificate.jpg" className="art-link art-color-link art-w-chevron"> <span> Diplome </span> </a> */}
                                        </div>
                                    </div>
                                    <div className="art-timeline-item">
                                        <div className="art-timeline-mark-light"></div>
                                        <div className="art-timeline-mark"></div>
                                        <div className="art-timeline-content">
                                            <div className="art-card-header">
                                                <div className="art-left-side">
                                                    <h5> <span> Isra university </span></h5>
                                                    <div className="art-el-suptitle mb-15"> 
                                                        <span> Student </span>
                                                    </div>
                                                </div>
                                                <div className="art-right-side"> 
                                                    <span className="art-date"> <span> Oct 2014 ~ Jul 2017 </span> </span>
                                                </div>
                                            </div>
                                            <div className="art-el-description">
                                                <p>Bachelor's Degree in Computer Multimedia Systems</p>
                                            </div> 
                                            {/* <a href="https://bslthemes.com/arter-demo/wp-content/uploads/2020/09/certificate.jpg" className="art-link art-color-link art-w-chevron"> <span> Diplome </span> </a> */}
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="elementor-column-wrap elementor-element-populated">
                        <div className="elementor-widget-wrap">
                            <div className="elementor-widget-container">
                                <div className="art-section-title">
                                    <div className="art-title-frame">
                                        <h4 className="art-title-h"> <span> Work History </span></h4>
                                    </div>
                                </div>
                                <div className="art-timeline">
                                    <div className="art-timeline-item">
                                        <div className="art-timeline-mark-light"></div>
                                        <div className="art-timeline-mark"></div>
                                        <div className="art-timeline-content">
                                            <div className="art-card-header">
                                                <div className="art-left-side">
                                                    <h5> <span> Freelance </span></h5>
                                                    <div className="art-el-suptitle mb-15"> 
                                                        <span> Full Stack Developer </span>
                                                    </div>
                                                </div>
                                                <div className="art-right-side"> 
                                                    <span className="art-date"> <span> Jan 2021 - Now </span> </span>
                                                </div>
                                            </div>
                                            <div className="art-el-description">
                                                <p>Custom development that ranges from small SPA apps large projects using frameworks like React and Angular</p>
                                            </div> 
                                            {/* <a href="https://bslthemes.com/arter-demo/wp-content/uploads/2020/09/certificate.jpg" className="art-link art-color-link art-w-chevron"> <span> Diplome </span> </a> */}
                                        </div>
                                    </div>
                                    <div className="art-timeline-item">
                                        <div className="art-timeline-mark-light"></div>
                                        <div className="art-timeline-mark"></div>
                                        <div className="art-timeline-content">
                                            <div className="art-card-header">
                                                <div className="art-left-side">
                                                    <h5> <span> MGS Software </span></h5>
                                                    <div className="art-el-suptitle mb-15"> 
                                                        <span> Senior Front-end Developer </span>
                                                    </div>
                                                </div>
                                                <div className="art-right-side"> 
                                                    <span className="art-date"> <span> Nov 2019 - Jan 2021 </span> </span>
                                                </div>
                                            </div>
                                            <div className="art-el-description">
                                                <p> Produced stunning visual elements of web applications by translating UI/UX design wireframes into code while producing high quality, reusable markup using Angular framework </p>
                                                <p>Ensure efficient web development by supporting designers and app developers while resolving website performance issues</p>
                                            </div> 

                                            {/* <a href="https://bslthemes.com/arter-demo/wp-content/uploads/2020/09/certificate.jpg" className="art-link art-color-link art-w-chevron"> <span> Diplome </span> </a> */}
                                        </div>
                                    </div>
                                    <div className="art-timeline-item">
                                        <div className="art-timeline-mark-light"></div>
                                        <div className="art-timeline-mark"></div>
                                        <div className="art-timeline-content">
                                            <div className="art-card-header">
                                                <div className="art-left-side">
                                                    <h5> <span> 359 Software </span></h5>
                                                    <div className="art-el-suptitle mb-15"> 
                                                        <span> Project Manager </span>
                                                    </div>
                                                </div>
                                                <div className="art-right-side"> 
                                                    <span className="art-date"> <span> Jun 2018 - may 2019 </span> </span>
                                                </div>
                                            </div>
                                            <div className="art-el-description">
                                                <p>Build cross-platform desktop apps on Ubuntu operating system using ElectronJs, React framework and NodeJs</p>
                                                <p>Manage software project teams using Agile SCRUM practices</p>
                                            </div> 
                                            {/* <a href="https://bslthemes.com/arter-demo/wp-content/uploads/2020/09/certificate.jpg" className="art-link art-color-link art-w-chevron"> <span> Diplome </span> </a> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
      </section>
    )
  }
}
export default ResumeSection
